(ns common.opensearch.trigram
  "The search of a text inside a word, for example \"wind\" in \"Nordwind\".

   The document holds each short text value of the entity itself a second time,
   under the root `trigram`, and the index splits it into trigrams: the parts of
   three characters, in order. A field of a linked entity has no trigrams. A
   phrase match of the trigrams of a query finds the query inside a word. A long
   text (multiline or rich text) has no trigrams: it would make the index much
   larger, and a long text is found by the start of a word only.")

(def data-types
  "The data types of the short texts that have trigrams."
  #{:data.type/text
    :data.type/text-simple
    :data.type/text-multi
    :data.type/text-url
    :data.type/url-multi
    :data.type/email
    :data.type/email-multi})

(def min-length
  "The shortest word that the trigrams find: one trigram."
  3)

(def root
  "The root of the trigram fields in the document."
  "trigram")

(defn field
  "The trigram field of the flat field `flat-field`, for example
   `trigram.oppo-name` for `flat.oppo-name`. Nil for a field that is not flat."
  [flat-field]
  (when (and (string? flat-field)
             (re-find #"^flat\." flat-field))
    (str root "." (subs flat-field (count "flat.")))))
